import React from "react";
import star from "../../../styles/img/newCheckout/star.svg";
import './slider.css'

const reviewSlidesData = [
    {
        slideClass: "slide_1",
        rating: 5,
        heading: "Avis clients",
        reviewText: "Accompagnement tout au long de ma procédure, professionalisme et efficacité",
        customerName: "Bilal — devenu coursier en Février 2020"
    },
    {
        slideClass: "slide_2",
        rating: 5,
        heading: "Avis clients",
        reviewText: "Démarche rapide et 100% digitalisée! j'ai gagné beaucoup de temps!",
        customerName: "Flora — devenue coursière en Février 2020"
    },
    {
        slideClass: "slide_3",
        rating: 5,
        heading: "Avis clients",
        reviewText: "Avec LegalPlace j'ai pu finir ma démarche vite fait! Je recommande vivement!!!",
        customerName: "Lucas — devenu coursier en Janvier 2020"
    }
]

const Rating = ({rating}) => {
    let index = 0
    return (
    <span>
        {
            [...Array(rating)].map(() => {
               index++
               return <img className="star" src={star}  key={`star_${index}`}/>})
        }
    </span>
)}

const Slide = ({slideClass, rating, heading, reviewText, customerName}) => {
    return (
        <div className={`slide ${slideClass}`}>
            <div className="slide-header">
                <Rating rating={rating} />
                <span className="slide-text-header">{heading}</span>
            </div>
            <p className="slide-body">{reviewText}
            </p>
            <p className="slide-footer">{customerName}</p>
        </div>
    )
}

const Slider = () => {
    return (
        <div className="slider-wrapper">
            <div className="slideshow-container">
                <div className="slide-container">
                    {
                        reviewSlidesData.map((slideElement, index) => {
                            const { 
                                slideClass,
                                rating,
                                heading,
                                reviewText,
                                customerName
                            } = slideElement

                            return (
                                <Slide 
                                    key={`reviewSlide_${index + 1}`}
                                    slideClass={slideClass}
                                    rating={rating}
                                    heading={heading}
                                    reviewText={reviewText}
                                    customerName={customerName}
                                />
                            )
                            }
                        )
                    }
                </div>
            </div>
            <div className="loading"><span>.</span><span>.</span><span>.</span></div>
        </div>
    )
}

export default Slider;



// WEBPACK FOOTER //
// ./src/components/buy/Checkout/Slider.js